import axios, { AxiosRequestConfig } from 'axios';
import { getOdataRootUrl } from '@bingads-webui-react/copilot-utils';
import { formatTodayDate } from './utils';
import type { AccountRouteProps, AuthorizedRequestProps, ODataQueryParams } from './types';

interface IGetTagUrlProps extends AccountRouteProps {
  params?: ODataQueryParams;
}

const tagOdataConfig = {
  $top: '200',
  $count: 'true',
  startDate: formatTodayDate(),
  endDate: formatTodayDate(),
};

export interface IFetchTagDataProps extends IGetTagUrlProps, AuthorizedRequestProps {}

export function getFetchTagUrl({
  customerId,
  accountId,
  params = tagOdataConfig,
}: IGetTagUrlProps) {
  const queryString = new URLSearchParams(params);

  return `${getOdataRootUrl()}/ODataApi/Campaign/V2/Customers(${customerId})/Accounts(${accountId})/Tags?${queryString}`;
}

export function fetchTag({
  accountId,
  customerId,
  ccToken,
}: IFetchTagDataProps) {
  const url = getFetchTagUrl({ customerId, accountId });

  return axios.get(
    url,
    {
      headers: {
        Authorization: ccToken,
        'content-type': 'application/json',
      },
      withCredentials: true,
    } as AxiosRequestConfig
  );
}
